import { HomePageContainer } from "./HomePage.style";
import { Fade } from "react-awesome-reveal";

export const HomePage = ({ chapters }) => {
  return (
    <HomePageContainer>
      <div className="bgVideo">
        <video autoPlay muted loop>
          <source src="/images/videos/homePageBgVideo.mp4" type="video/mp4" />
        </video>
      </div>
      <Fade direction="up" triggerOnce>
        {/* <div className="event">
          <div className="city">
            <div className="circle">
              <img src="/images/12.webp" alt="shape" />
            </div>
            <div className="text">
              <p>Novi sad</p>
              <p>Petrovaradin</p>
            </div>
            <div className="orange1">
              <img src="/images/11.webp" alt="shape" />
              <p className="date">MAJ 2023</p>
            </div>
            <div className="orange2">
              <img src="/images/11.webp" alt="shape" />
            </div>
            <div className="orange3">
              <img src="/images/11.webp" alt="shape" />
            </div>
          </div>
        </div> */}
        <div
          className="ns_logo"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img alt="ns_logo" src="/images/led-logo.png" />
          {/* <img alt="ns_logo" src="/images/irvasi.png" style={{ width: "40%", height: "auto" }} /> */}
        </div>
      </Fade>
      <div className="glow_wrapper">
        <img src="/images/glow.png" alt="glow" />
      </div>
      <div className="text_express">
        {/* <p>A UJUTRU SVAKO SVOJOJ KUĆI <span className="highlight">EKSPRESNO!</span></p> */}
        <p>
          {/* 🎟️ Već četvrtu godinu za redom, festival koji svi čekaju, vraća se sa istom strašću i još više energije! */}
          {/* <br /> */}
          {/* <br />
         Ove godine nastupaju izvođači koje jednostavno ne smete propustiti!<br />
Ne čekaj da ti pričaju kako je bilo, ulaznice nabavi putem sajta tickets.rs ili na njihovim blagajnama. */}
 <p className="front-text-first">
          Osiguraj rani pristup najpovoljnijim kartama.<br/>
Pridruži se Dragi Bravo članovima i budi prvi u redu za novogodišnje Dragi Bravo veselje! 🎟️
        </p>

          {chapters?.map((chapter) => (
            <>
              {chapter.text && (
                <>
                  {/* <br />
                  <br /> */}
                  {chapter.text}
                </>
              )}
            </>
          ))}
        </p>
        {chapters?.[0]?.id === 0 && (
          <div className="btns">
            <div className="btn">
              <a
                href="https://forms.gle/19tZbbHe5yfGaeim6"
                target="_blank"
                rel="noreferrer"
              >
                <button>POSTANI ČLAN I UDJI U 1. FAZU PRODAJE</button>
              </a>
            </div>
          </div>
        )}
        {/* <p>
          Osiguraj rani pristup najpovoljnijim kartama.
Pridruži se Dragi Bravo članovima i budi prvi u redu! 🎟️
        </p> */}
          <p className="front-text-first">
         Prijavi svoj dolazak i izaberi događaj koji želiš da posetiš.
Tvoja podrška se pamti — vidimo se uskoro! 💫
        </p>
         <div className="btns">
            <div className="btn">
              <a
                href="https://forms.gle/5za7ufXVBHcHGPQ36"
                target="_blank"
                rel="noreferrer"
              >
                <button>DOLAZIM SA GODIŠNJOM ULAZNICOM</button>
              </a>
            </div>
          </div>
        
      {/* <div className="btns">
        <div className="btn">
          <button>
            <a
              href="https://tickets.rs/tour/dragi_bravo_festival_2025_2219"
              target="_blank"
              rel="noreferrer"
            >
              KUPI KARTU
            </a>
          </button>
        </div>
      </div> */}
      </div>
      <div className="glow_wrapper">
        <img src="/images/glow.png" alt="glow" />
      </div>
      <div className="partners">
        <div className="icon">
          <img src="/images/icons/5.webp" alt="icon" />
        </div>
        <div className="icon">
          <img src="/images/icons/6.webp" alt="icon" />
        </div>
        <div className="icon">
          <img src="/images/icons/7.webp" alt="icon" />
        </div>
        <div className="icon">
          <img src="/images/icons/8.webp" alt="icon" />
        </div>
        <div className="icon">
          <img src="/images/icons/9.webp" alt="icon" />
        </div>
        <div className="icon">
          <img src="/images/icons/pepsi.png" alt="icon" />
        </div>
      </div>
    </HomePageContainer>
  );
};
